/**
 * shop-hero.js v3 — FlorixSports
 * Matches HeroCarousel.jsx logic exactly:
 *
 * goTo(next):
 *   1. setAnimating(true)  → panel fades out (300ms)
 *   2. After 300ms: setCurrent(next) → bg swaps, new panel fades in
 *   3. After 700ms more: setAnimating(false)
 *
 * Background images: opacity transition 700ms (independent)
 * Content panels:    opacity + translateY transition 300ms
 */

(function () {
  'use strict';

  var hero = document.querySelector('.shop-hero');
  if (!hero) return;

  var bgLayers = Array.from(hero.querySelectorAll('.shop-hero__bg-layer'));
  var panels   = Array.from(hero.querySelectorAll('.shop-hero__panel'));
  var dots     = Array.from(hero.querySelectorAll('.shop-hero__dot'));
  var prevBtn  = hero.querySelector('.shop-hero__arrow--prev');
  var nextBtn  = hero.querySelector('.shop-hero__arrow--next');
  var counterEl = hero.querySelector('.shop-hero__counter-current');

  var total    = bgLayers.length;
  if (total === 0 || total !== panels.length) return;

  var current   = 0;
  var animating = false;
  var timer     = null;

  /* ── Helper: zero-padded number ── */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ── Core transition — matches JSX goTo exactly ── */
  function goTo(nextIndex) {
    if (animating) return;
    var next = ((nextIndex % total) + total) % total;
    if (next === current) return;

    animating = true;

    /* Step 1: fade out current content panel (300ms) */
    panels[current].classList.remove('is-active');

    setTimeout(function () {
      /* Step 2: swap bg + activate new panel */
      bgLayers[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = next;

      bgLayers[current].classList.add('is-active');
      panels[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
      if (counterEl) counterEl.textContent = pad(current + 1);

      /* Step 3: unlock after bg transition finishes (700ms) */
      setTimeout(function () { animating = false; }, 750);

    }, 300); /* content fade duration */
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  /* ── Auto-advance (5 s, matches JSX setInterval) ── */
  function startTimer() {
    clearInterval(timer);
    timer = setInterval(next, 5000);
  }
  startTimer();

  /* ── Arrow buttons ── */
  if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startTimer(); });
  if (nextBtn) nextBtn.addEventListener('click', function () { next(); startTimer(); });

  /* ── Dot buttons ── */
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goTo(i); startTimer(); });
  });

  /* ── Keyboard navigation ── */
  hero.setAttribute('tabindex', '0');
  hero.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown')  { next(); startTimer(); }
    if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')    { prev(); startTimer(); }
  });

  /* ── Pause on hover, resume on leave ── */
  hero.addEventListener('mouseenter', function () { clearInterval(timer); });
  hero.addEventListener('mouseleave', startTimer);

  /* ── Pause when tab is hidden ── */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) clearInterval(timer); else startTimer();
  });

  /* ── Touch/swipe (mobile) ── */
  var touchStartX = 0;
  hero.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].clientX;
  }, { passive: true });
  hero.addEventListener('touchend', function (e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? next() : prev();
      startTimer();
    }
  }, { passive: true });

})();
